import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full flex justify-center items-center mt-8 py-2"
}
const _hoisted_2 = { class: "flex flex-wrap justify-center items-center space-x-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["onClick", "aria-label", "aria-current"]
const _hoisted_5 = {
  key: 1,
  class: "px-2 py-2 text-gray-500 flex items-center"
}
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.meta && _ctx.meta.totalPages > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePageChange(_ctx.currentPage - 1))),
            disabled: _ctx.currentPage === 1,
            class: _normalizeClass([
          'px-4 py-2 rounded-md transition-colors duration-200',
          _ctx.currentPage === 1
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gray-800 text-gray-300 hover:bg-gray-700',
        ]),
            "aria-label": 'Prethodna stranica'
          }, " « ", 10, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationRange, (page) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (page !== '...')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (typeof page === 'number' ? _ctx.handlePageChange(page) : null),
                    class: _normalizeClass([
            'px-4 py-2 rounded-md transition-colors duration-200',
            _ctx.currentPage === page
              ? 'bg-green-600 text-white font-semibold'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700',
          ]),
                    "aria-label": `Stranica ${page}`,
                    "aria-current": _ctx.currentPage === page ? 'page' : undefined
                  }, _toDisplayString(page), 11, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, " ... "))
            ], 64))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePageChange(_ctx.currentPage + 1))),
            disabled: _ctx.currentPage === _ctx.meta.totalPages,
            class: _normalizeClass([
          'px-4 py-2 rounded-md transition-colors duration-200',
          _ctx.currentPage === _ctx.meta.totalPages
            ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
            : 'bg-gray-800 text-gray-300 hover:bg-gray-700',
        ]),
            "aria-label": 'Sledeća stranica'
          }, " » ", 10, _hoisted_6)
        ])
      ]))
    : _createCommentVNode("", true)
}